<div
    class="sc-select"
    scClickOutside
    [class.sc-select--with-label]="!!label"
    [class.sc-select--readonly]="isReadonly"
    [class.sc-select--disabled]="isDisabled"
    (onClickOutSide)="onClickOutside()"
    (keydown)="onKeydown($event)"
>
    <sc-input #scInput
        [autocomplete]="autocomplete"
        [formControl]="inputField"
        [icon]="setInputIcon()"
        [id]="formControlName ? (id ? formControlName + '-' + id : formControlName) : null"
        [isDisabled]="isDisabled"
        [readonly]="isReadonly || !enableSearch"
        [errorMessages]="errorMessages"
        [hideError]="hideError"
        [label]="label"
        [placeholder]="placeholder"
        (click)="onClickInput($event.target.tagName)"
        (keyup)="applyFilter()"
        [iconClickHandler]="!(isDisabled || isReadonly || loading) && iconClickObservable"
        [maxlength]="maxlength"
        [debounceTime]="debounceTime"
    ></sc-input>
    <div class="sc-select__items sc-scroll-bar" [hidden]="!showItems || loading" [class.sc-select__items__down]="showItemsBelow"
    [class.sc-select__items__up]="!showItemsBelow && !label" [class.sc-select__items__up--with-label]="!showItemsBelow && label" #itemsElement>
        <ng-container *ngIf="filteredItems.length; else sinResultados">
            <div
                *ngFor="let item of filteredItems; let index = index"
                class="sc-select__scroll"
                [class.sc-select__item]="item.groupType || !hasGroupedItems"
                [class.sc-select__item--grouped]="hasGroupedItems && item.groupType"
                [class.sc-select__title]="hasGroupedItems && !item.groupType"
                [class.sc-select__item--selected]="index === selectedItemIndex"
                (click)="onSelectItem(index)"
            >{{ item[objectValue] }}</div>
        </ng-container>
        <ng-template #sinResultados>
            <div class="sc-select__item" disabled>No hay resultados</div>
        </ng-template>
    </div>
</div>
